// Created by carsonaberle at 4/13/21
import React, { useState } from 'react';
import './ui-partner-package.scss';
import './ui-partner-package-tablet.scss';
import './ui-partner-package-desktop.scss';
import { connect, useDispatch } from 'react-redux';
import { withApollo } from '@apollo/react-hoc';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { showErrorMessage, showSuccessMessage } from '../../../redux/store/Control';
import { setSelectedRegion, showOption } from '../../../redux/store/user/actions';
import UIIconButton from '../UIIconButton';
import { EditIcon, Trashcan } from '../../../assets/icons';
import UIModal from '../UIModal';
import UIOverlayCard from '../UIOverlayCard';
import CreatePartnerPackageModal from '../../modals/CreatePartnerPackageModal';
import UIPartnerPackageHelper from './UIPartnerPackageHelper';
import UIIcon from '../UIIcon';
import UICard from '../UICard/UICard';
import UIHover from '../UIHover/UIHover';
import { storeSelectedOption } from '../../../redux/store/options/actions';
import { UI_ICON_BUTTON_CANCEL_TYPE } from '../UIIconButton/config';

function UIPartnerPackage(props) {
	const { partnerPackage, partner, currentUser } = props;
	const [selectedPackage, setSelectedPackage] = useState(undefined);
	const [packageToDelete, setPackageToDelete] = useState(undefined);

	const dispatch = useDispatch();

	const editPackage = (partnerPackage) => {
		setSelectedPackage(partnerPackage);
	};

	const renderPartnerPackageBody = () => {
		const renderPartnerPackages = () => {
			if (partnerPackage.options.length > 0) {
				return partnerPackage.options.map((option) => {
					return (
						<div className='regionOption' key={option.id} onClick={() => dispatch(storeSelectedOption(option))}>
							<p className='regionOption__name'>{option.name}</p>
						</div>
					);
				});
			}
		};
		return (
			<UICard
				title={`$${partnerPackage.price / 100} ${partnerPackage.name}`}
				collapsable={true}
				className='partnerPackage--card'
				rightItem={
					<UIHover text={'edit this package'}>
						<UIIcon className='partnerPackage--edit' onClick={() => editPackage(partnerPackage)} iconSrc={EditIcon.white} alt={'edit'} />
					</UIHover>
				}>
				<div className='partnerPackage__header'>Package options</div>
				<div className='partnerPackage__options'>{renderPartnerPackages()}</div>
			</UICard>
		);
	};

	const renderUpdatePackageForPartnerModal = () => {
		const hideModal = () => setSelectedPackage(undefined);
		return (
			<UIModal hideModal={hideModal} condition={selectedPackage !== undefined}>
				<CreatePartnerPackageModal update partner={partner} packageToEdit={partnerPackage} onCreateFinished={hideModal} />
			</UIModal>
		);
	};

	const renderDeletePackageForPartnerModal = () => {
		const hideModal = () => setPackageToDelete(undefined);
		return (
			<UIModal condition={packageToDelete !== undefined}>
				<UIOverlayCard title={`Delete this package?`} hideModal={hideModal}>
					<UIIconButton
						type={UI_ICON_BUTTON_CANCEL_TYPE}
						dark
						text={`yes, delete`}
						onClick={() => UIPartnerPackageHelper.deleteSelectedPackage(packageToDelete, currentUser, partner, setPackageToDelete)}
						icon={Trashcan.grey}
					/>
				</UIOverlayCard>
			</UIModal>
		);
	};
	return (
		<div className='partnerPackage'>
			{renderPartnerPackageBody()}
			{renderUpdatePackageForPartnerModal()}
			{renderDeletePackageForPartnerModal()}
		</div>
	);
}

UIPartnerPackage.propTypes = {
	partnerPackage: PropTypes.object.isRequired
};

function mapStateToProps(state) {
	return {
		control: state.control,
		currentUser: state.currentUser,
		filters: state.filters
	};
}

const mapDispatchToProps = (dispatch) => bindActionCreators({ showErrorMessage, showSuccessMessage, showOption, setSelectedRegion }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withApollo(UIPartnerPackage));
